const debtOrderInfoFields = ['servicerName'];

const operators = {
  $and: function (row, constraint) {
    if (!Array.isArray(constraint))
      throw Error('Constraint of $and must be an array');
    for (let i = 0; i < constraint.length; i++) {
      if (!isRowSatisfied(row, constraint[i])) return false;
    }
    return true;
  },
  $or: function (row, constraint) {
    if (!Array.isArray(constraint))
      throw Error('Constraint of $or must be an array');
    for (let i = 0; i < constraint.length; i++) {
      if (isRowSatisfied(row, constraint[i])) return true;
    }
    return false;
  },
  $not: function (row, constraint) {
    if (Array.isArray(constraint)) {
      for (let i = 0; i < constraint.length; i++) {
        if (isRowSatisfied(row, constraint[i])) return false;
      }
      return true;
    } else {
      const a = row,
        b = constraint;
      return a != b;
    }
  },
  $gte: function (a, b) {
    return a >= b;
  },
  $lte: function (a, b) {
    return a <= b;
  },
  $gt: function (a, b) {
    return a > b;
  },
  $lt: function (a, b) {
    return a < b;
  },
  $ne: function (a, b) {
    return a != b;
  },
  $eq: function (a, b) {
    return a == b;
  },
  $in: function (a, b) {
    return b.includes(a);
  },
};

function isRowSatisfied(row, conditions) {
  if (typeof conditions !== 'object')
    throw Error('Conditions must be an object');
  if (Array.isArray(conditions)) throw Error('Conditions can not be an array');
  const keys = Object.keys(conditions);
  for (let i = 0; i < keys.length; i++) {
    if (!isSatisfied(row, keys[i], conditions[keys[i]])) return false;
  }
  return true;
}

function isSatisfied(row, key, constraint) {
  const rowValue = debtOrderInfoFields.includes(key)
    ? row.debtOrderContractInfo[key]
    : row[key];
  if (operators[key]) {
    return operators[key](row, constraint);
  } else if (typeof constraint === 'object') {
    const keys = Object.keys(constraint);
    for (let i = 0; i < keys.length; i++) {
      const operator = keys[i];
      if (!operators[operator]) throw Error('Invalid operator');
      if (!operators[operator](rowValue, constraint[operator])) return false;
    }
    return true;
  } else {
    return rowValue == constraint;
  }
}

export const query = function (list, conditions) {
  if (conditions) {
    const filter = function (row) {
      return isRowSatisfied(row, conditions);
    };
    list = list.filter(filter);
  }
  return list;
};

export const splitByCondition = function (list, conditions) {
  const excluded = [];
  if (conditions) {
    const filter = function (row) {
      const satisfied = isRowSatisfied(row, conditions);
      if (!satisfied) excluded.push(row as never);
      return satisfied;
    };
    list = list.filter(filter);
  }
  return [list, excluded];
};
